<div class="modal-body">
  <h3 class="text-center">Submitter Diagnostics 1: Diagnostics from Trial Balance</h3>
  <h4><i class="fa fa-info-circle"></i>&nbsp; FIR has analyzed your trial balance and identified some items you may wish to investigate. Please review each item. To clear the item click the diagnostic name. You may return to the Diagnostic screen at any time to view the status of your diagnostics.</h4>
  <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table">
    <thead>
      <tr>
        <th class="text-center">Counterparty</th>
        <th class="text-center">CP Domicile</th>
        <th class="text-center">Ledger Acct</th>
        <th class="text-center">Ledger Desc</th>
        <th class="text-center">Begin Balance</th>
        <th class="text-center">Year End Balance</th>
        <th class="text-center">Delta Balance</th>
        <th class="text-center">Action</th>
        <th class="text-center">Explanation</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>CP1415</td>
        <td>U</td>
        <td>002090000</td>
        <td>Capital Stock-Common</td>
        <td class="text-right">-356,763,946</td>
        <td class="text-right">-231,763,946</td>
        <td class="text-right">125,000,000</td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
  </table>
</div>
